import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

interface AbilityRule {
  action: string | string[];
  subject: string | string[];
  conditions?: Record<string, unknown>;
  fields?: string | string[];
  inverted?: boolean;
  reason?: string;
}

interface MyAbilitiesResponse {
  systemRole: "super_admin" | "admin" | "billing" | "user";
  endUserRole: "salesperson" | "crew_chief" | "manager" | null;
  accountId: string;
  businessId: string | null;
  rules: AbilityRule[];
}

// ADV-896: hits the new /auth/me/abilities endpoint. The endpoint is gated by
// requireAbility("read", "User") — billing/end-user roles get a 403 by design
// (the tracer-bullet proves the middleware actually runs). Callers should
// surface the error state rather than retry.
export function useMyAbilities() {
  return useQuery<MyAbilitiesResponse>({
    queryKey: ["auth", "me", "abilities"],
    queryFn: () => api.get<MyAbilitiesResponse>("/auth/me/abilities"),
    retry: false,
  });
}
